var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.75C14 1.19772 13.5523 0.75 13 0.75H3.5C3.01675 0.75 2.625 1.14175 2.625 1.625C2.625 2.10825 3.01675 2.5 3.5 2.5H11.25C11.8023 2.5 12.25 2.94772 12.25 3.5V13C12.25 13.4832 12.6418 13.875 13.125 13.875C13.6082 13.875 14 13.4832 14 13V1.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.375,
    width: 11.375,
    height: 13.125,
    rx: 1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.eeddd79e55b60595f3289732811ef9e0.svg";
export { ForwardRef as ReactComponent };